import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMessage } from '@gef-ui/localization/messages';

import { subheaders } from 'features/common/Subheader/constants';
import { getCampaignsNearingTheEndContactRelease } from 'features/views/dashboard/todaysUrgencies/selectors';
import { getRoutePath } from 'utils/routeHelper';
import CampaignsNearingTheEndTemplate from 'pages/Dashboard/components/CampaignsNearingTheEndTemplate';

export const CampaignsNearingTheEndContactRelease = () => {
	const navigate = useNavigate();
	const campaignsNearingTheEndContactRelease = useSelector(getCampaignsNearingTheEndContactRelease);

	const handleCampaignClick = useCallback(
		(campaignId) => {
			const pathname = getRoutePath('campaignManagement', { campaignId });
			navigate({ pathname, search: '?contactState=1' });
		},
		[navigate],
	);

	return (
		<CampaignsNearingTheEndTemplate
			items={campaignsNearingTheEndContactRelease}
			text={getMessage('dashboard:todaysUrgencies.campaignsNearingTheEndContactRelease')}
			subheaderId={subheaders.campaignsNearingTheEndContactRelease}
			onClickFn={handleCampaignClick}
		/>
	);
};

export default CampaignsNearingTheEndContactRelease;
